import { render, staticRenderFns } from "./lrCountUp.vue?vue&type=template&id=bbff8cd2"
import script from "./lrCountUp.vue?vue&type=script&lang=js"
export * from "./lrCountUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports